<template>
  <div>
    <div class="details-stack">
      <v-row>
        <v-col cols="12">
          <AppSelectField :model-value="business_type" :items="businessTypeOptions" item-title="label"
            item-value="value" label="Business Type" label-icon="mdi-briefcase-outline"
            placeholder="Select business type" :error-messages="errors.business_type ? [errors.business_type] : []"
            @update:modelValue="$emit('update:business_type', String($event || ''))" />
        </v-col>

        <v-col cols="12">
          <AppSelectField :model-value="service_category" :items="serviceCategoryOptions" item-title="label"
            item-value="value" label="Service Category" label-icon="mdi-shape-outline"
            placeholder="Select service category"
            :error-messages="errors.service_category ? [errors.service_category] : []"
            @update:modelValue="$emit('update:service_category', String($event || ''))" />
        </v-col>
      </v-row>
    </div>
  </div>
</template>

<script setup lang="ts">
import AppSelectField from "@/shared/components/ui/AppSelectField.vue";

withDefaults(
  defineProps<{
    business_type: string;
    service_category: string;
    businessTypeOptions: Array<{ label: string; value: string }>;
    serviceCategoryOptions: Array<{ label: string; value: string }>;
    errors: {
      business_type?: string;
      service_category?: string;
    };
  }>(),
  {
    business_type: "",
    service_category: "",
    businessTypeOptions: () => [],
    serviceCategoryOptions: () => [],
    errors: () => ({}),
  },
);

defineEmits([
  "update:business_type",
  "update:service_category",
]);
</script>

<style scoped>
.details-stack {
  display: flex;
  flex-direction: column;
  gap: 14px;
}
</style>
